import { UseFormReturn } from 'react-hook-form';

export type Rating = 1 | 2 | 3 | 4 | 5;

export enum OrderAgain {
  Yes = 'Yes',
  No = 'No',
  Maybe = 'Maybe',
}

export interface FormValues {
  orderAgain?: OrderAgain;
  orderAgainQuestionOrder?: string;
  orderAgainFollowUp?: Array<string>;
  orderAgainFollowUpOther?: string;
  rating?: Rating;
  isSubmitting?: boolean;
}

export type FormContext = UseFormReturn<FormValues>;
